import React, { useEffect, useState } from "react";
import { RefreshCw, ArrowRight } from "lucide-react";
import { getInsights } from "../lib/api";
import { motion } from "framer-motion";
import { BlobSticker } from "./DecorativeShapes";

export default function InsightCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (refresh = false) => {
    try {
      if (refresh) setRefreshing(true);
      else setLoading(true);
      const d = await getInsights(refresh);
      setData(d);
    } catch {}
    setLoading(false);
    setRefreshing(false);
  };
  useEffect(() => { load(false); }, []);

  return (
    <div
      className="surface-card border border-border plush-shadow-sm relative overflow-hidden rounded-[24px] p-6"
      data-testid="home-insight-card"
    >
      <div className="absolute -top-20 -right-20 h-44 w-44 rounded-full bg-primary/10 blur-3xl" />

      <div className="relative flex items-center justify-between gap-2">
        <p className="text-[10px] uppercase tracking-wider opacity-60 font-extrabold text-primary">Today's intelligence</p>
        <button
          onClick={() => load(true)}
          className="opacity-50 hover:opacity-100 transition-opacity"
          aria-label="Refresh insight"
          data-testid="home-insight-refresh"
        >
          <RefreshCw size={14} className={refreshing ? "animate-spin" : ""} />
        </button>
      </div>

      <div className="relative mt-3">
        {loading ? (
          <div className="space-y-2.5">
            <div className="shimmer h-7 w-3/4 rounded-full" />
            <div className="shimmer h-4 w-full rounded-full" />
            <div className="shimmer h-4 w-5/6 rounded-full" />
          </div>
        ) : (
          <motion.div initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}>
            <h3 className="text-[24px] leading-[1.12] font-extrabold tracking-tight" data-testid="home-insight-title">
              {data?.title}
            </h3>
            <p className="text-[14px] opacity-75 mt-2 leading-relaxed font-medium" data-testid="home-insight-body">
              {data?.body}
            </p>
            {data?.action && (
              <button className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-primary hover:gap-2 transition-all" data-testid="home-insight-action">
                {data.action} <ArrowRight size={14} />
              </button>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
}
